'use client';

import { Button } from '@savvy-kit/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@savvy-kit/components/dropdown-menu';
import { cn } from '@savvy-kit/lib/utils';
import { ListFilter } from 'lucide-react';

import type { DataTableFiltersSlotProps } from '../../types/toolbar-slot-props';
import { FilterRenderer } from '../filters/filter-renderer';

export type DataTableFiltersProps = DataTableFiltersSlotProps;

export function DataTableFilters({ columns, onFilterChange, className }: DataTableFiltersProps) {
  if (columns.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger render={<Button variant="secondary" size="sm" className={cn('gap-2', className)} />}>
        <ListFilter className="h-4 w-4" />
        <span>Filter</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuLabel>Filter by</DropdownMenuLabel>
        {columns.map((col) => (
          <DropdownMenuSub key={col.id}>
            <DropdownMenuSubTrigger>{col.label}</DropdownMenuSubTrigger>
            <DropdownMenuSubContent className="min-w-56 p-0">
              <FilterRenderer
                filterType={col.filterType}
                filterMeta={col.filterMeta}
                options={col.options}
                range={col.range}
                value={col.currentValue}
                onChange={(value) => onFilterChange(col.id, value)}
              />
            </DropdownMenuSubContent>
          </DropdownMenuSub>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
